export default __webpack_public_path__ + "static/media/tick.660e1899.svg";